export const DEFAULT_EMAIL_SUBJECT = 'Reminder: {{check_in_name}} check-in due {{due_date}}';

export const DEFAULT_EMAIL_MESSAGE = `Hi {{first_name}},

This is a friendly reminder that your {{check_in_name}} check-in is due on {{due_date}} at {{due_time}}.

Please submit your update using this link: {{check_in_link}}

Thanks!`;

export const DEFAULT_SLACK_MESSAGE = `Hi {{first_name}}! 👋

Your {{check_in_name}} check-in is due on {{due_date}} at {{due_time}}.

Submit your update here: {{check_in_link}}`;

export const AVAILABLE_VARIABLES = [
  { 
    category: 'Participant', 
    variables: [
      { key: '{{first_name}}', description: 'Participant\'s first name' },
      { key: '{{last_name}}', description: 'Participant\'s last name' },
      { key: '{{full_name}}', description: 'Participant\'s full name' },
      { key: '{{participant_timezone}}', description: 'Participant\'s timezone' }
    ]
  },
  { 
    category: 'Check-in', 
    variables: [
      { key: '{{check_in_name}}', description: 'Name of the check-in' },
      { key: '{{check_in_link}}', description: 'Direct link to submit the check-in' },
      { key: '{{due_date}}', description: 'When check-in is due (formatted date)' },
      { key: '{{due_time}}', description: 'Time when check-in is due' }
    ]
  },
  { 
    category: 'Organization', 
    variables: [
      { key: '{{organization_name}}', description: 'Organization name' },
      { key: '{{reminder_sender_name}}', description: 'Name of person who created the check-in' }
    ]
  }
];

export const REQUIRED_VARIABLES = ['{{check_in_link}}']; 